var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.isBusy
    ? _c(
        "b-form-select",
        _vm._b(
          {
            staticClass: "form-control",
            staticStyle: { "min-width": "130px" },
            attrs: { options: _vm.options },
            on: { change: _vm.recordTicketCollector },
            scopedSlots: _vm._u(
              [
                {
                  key: "first",
                  fn: function() {
                    return [
                      _c("b-form-select-option", { attrs: { value: null } }, [
                        _vm._v("\n      Cobrador\n    ")
                      ])
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              641827194
            ),
            model: {
              value: _vm.selectedTicketCollector,
              callback: function($$v) {
                _vm.selectedTicketCollector = $$v
              },
              expression: "selectedTicketCollector"
            }
          },
          "b-form-select",
          _vm.$attrs,
          false
        )
      )
    : _c("b-skeleton", {
        staticStyle: { "min-width": "100px" },
        attrs: { animation: "wave" }
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }